import React, { useEffect } from 'react';
import Canvas from './Canvas.js';
import { motion } from "framer-motion";


const Thumbnail = props => {
  const shortenAddress = address => (address.substr(0,6) + "..." + address.substr(address.length-4, 4))
    return (
        <motion.div 
          className="column is-one-third-tablet ">
            <div className="is-relative has-text-white" >
                <Canvas element={props.token.id} token={props.token} display="canvas" setFullscreenCanvas={props.setFullscreenCanvas} />
            </div>
        <div className="columns is-mobile ">
          <div className="column is-half">
            <p className="sp-label">Hash</p>
            <p className="is-size-7">{shortenAddress(props.token.hash)}</p>
          </div>
        </div>
      </motion.div>
    )
};

const Footer = props => {
  return (
    <footer className="section has-text-centered">
      <a className="button is-size-7 is-primary is-rounded is-outlined" href={"https://artblocks.io/project/17"}  target="_blank" rel="noreferrer">See more on Artblocks.io</a>
    </footer>
  )
};

const Gallery = props => {
  const isNegative = false;
  useEffect(()=> {
    props.setCanvas({enabled:false, display:"foreground", token:props.tokenList[399]});
  },[props.tokenList]);

  return (
    <>
    <motion.section 
       initial={{y:50, opacity:0}}
       animate={{y:0, opacity:1}}
       transition={{delay:0.1, duration:0.5}}
       className="section main has-text-black"
      >
      <div className="columns is-multiline">
        {props.tokenList.filter((token, index)=>index>390).reverse().map((token, index) => (
          <Thumbnail
            setFullscreenCanvas={props.setCanvas} 
            token={token}
            key={index}
          />
        ))}
      </div>
      <Footer />

    </motion.section>
  </>
  )
  };
export default Gallery;